import React from "react";
import "./Card.css";
export const Card = React.forwardRef((props, ref) => {
  const { inverseColor, children, className, ...rest } = props;
  return (
    <div
      ref={ref}
      {...rest}
      className={`card ${inverseColor ? "card-inverse" : ""} ${className}`}
    >
      {children}
    </div>
  );
});
Card.displayName = "Card";
